import React from "react";
import { motion } from "framer-motion";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import {  MapPin, Briefcase, Star } from "lucide-react";

export default function CandidateCard({ candidate }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm hover:shadow-md transition-all"
    >
      <div className="flex items-start gap-4">

        <Avatar className="h-14 w-14 border border-slate-200">
          <AvatarImage src={candidate.photo_url} />
          <AvatarFallback>
            {candidate.full_name?.slice(0, 1)}
          </AvatarFallback>
        </Avatar>

        <div className="flex-1">
          <h3 className="text-lg font-semibold text-slate-900">
            {candidate.full_name}
          </h3>

          <p className="text-sm text-slate-600">
            {candidate.current_title} at {candidate.current_company}
          </p>

          <div className="flex flex-wrap gap-3 text-sm text-slate-500 mt-3">
            {candidate.location && (
              <span className="flex items-center gap-1">
                <MapPin className="w-4 h-4" />
                {candidate.location}
              </span>
            )}

            {candidate.experience_years && (
              <span className="flex items-center gap-1">
                <Briefcase className="w-4 h-4" />
                {candidate.experience_years} yrs
              </span>
            )}

            {candidate.rating && (
              <span className="flex items-center gap-1 text-amber-500">
                <Star className="w-4 h-4" />
                {candidate.rating}/5
              </span>
            )}
          </div>
        </div>

      </div>
    </motion.div>
  );
}
